import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CountoModule } from 'angular2-counto';

import { ModalModule, BsDropdownModule } from 'ngx-bootstrap';
import { BsDatepickerModule, BsDatepickerConfig, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { NgxBootstrapDatePickerConfigService } from '../assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';


import { UtilsModule } from '../shared/utils/utils.module';


// Data table modules
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

//ngx currency
import { NgxCurrencyModule } from 'ngx-currency';

import { UpdateFieldModule } from './update-field/update-field.module';
import { UpdateFieldComponent } from './update-field/update-field.component';

//NgxBootstrapDatePickerConfigService.registerNgxBootstrapDatePickerLocales();

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule,
        UtilsModule,
        CountoModule,
        BsDatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        ProgressSpinnerModule,
        NgxCurrencyModule,
        PanelModule,

        UpdateFieldModule
    ],
    declarations: [
        
    ],
    entryComponents: [
    ],
    exports: [
        UpdateFieldComponent
    ],
    providers: [
        { provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig },
        { provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig },
        { provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale },
    ]
})
export class MasterCommonModule { }
